import { ScrapedTeamMember, ScraperRunRecord } from '../redux/scraper/scraperSlice';

// The is_clinician boolean is the single source of truth for whether a team member is a Clinician
export const isClinicianMember = (member: ScrapedTeamMember): boolean =>
  member.is_clinician === true;

const kebab = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Map a scraped team member to the full clinician document expected by POST /clinician/bulk-save.
// The endpoint only inserts when given the complete document shape.
export const scrapedMemberToClinician = (
  member: ScrapedTeamMember,
  practiceId: string,
  opts?: { subscriptionId?: string }
) => {
  const now = Math.floor(Date.now() / 1000);
  const nameParts = (member.name || '').trim().split(/\s+/);
  const titles = member.titles || [];
  const title = titles[0] || '';

  const doc: Record<string, any> = {
    simplePracticeClinicianId: member.id || '',
    firstName: nameParts[0] || '',
    lastName: nameParts.slice(1).join(' '),
    fullName: member.name || '',
    email: member.email || '',
    emailSource: 'settings_teams',
    npiNumber: '',
    title,
    titles,
    role: 'Clinician',
    status: 'new',
    phone: '',
    specialties: [],
    licenses: [],
    availability: {
      open: [],
      booked: [],
      cancelled: [],
      outOfOffice: [],
      blocked: []
    },
    availabilityUpdatedAt: now,
    slug: kebab(`${member.name || ''} ${title} ${member.id || ''}`),
    isActive: false,
    id_practice: practiceId,
    createdAt: now,
    updatedAt: now,
    profile: {
      detailsImportedAt: now,
      detailsSource: 'team_member_edit_page',
      editUrl: member.url || ''
    },
    ageRange: [],
    bio: '',
    education: [],
    gender: '',
    insuranceAccepted: [],
    languages: [],
    location: [],
    modality: [],
    phone_number: '',
    profileImage: '',
    sessionTypes: [],
    vslVideo: '',
    vsl_url: ''
  };

  if (opts?.subscriptionId) {
    doc.subscriptionId = opts.subscriptionId;
    doc.subscriptionActivatedAt = now;
  }

  return doc;
};

// Scraper run timestamps are unix seconds
export const formatRunDate = (run: ScraperRunRecord | null): string => {
  if (!run?.created_at) return 'Never';
  const date = new Date(run.created_at * 1000);
  if (isNaN(date.getTime())) return 'Never';
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
};
